import { LogisticalDeclarationExcelData } from '../../../types'
import { Row } from './types'
import { addRowStyles, borderThin, COLOR } from './utils'

export function getRowProvider(data: LogisticalDeclarationExcelData[]) {
    const row: Row[] = [{ value: 'Proveedor' }]
    data.forEach(d => {
        row.push({
            value: ''
        })
        row.push({
            value: ''
        })
        row.push({
            value: ''
        })
        row.push({
            align: 'center',
            value: d.logistical_declaration_receptions
                .map(ldr => ldr.provider.commercial_name)
                .join('/')
        })
        return row.push({
            value: '',
            backgroundColor: COLOR.gray
        })
    })
    return addRowStyles(row, [borderThin])
}
